import { Header } from "@/components/Header";
import type { ErrorLayoutProps } from "./ErrorLayoutProps";
import classes from "./ErrorLayout.module.scss";
import { clsx } from "clsx";
import { Container } from "@/components/ui/Container";
import { Heading } from "@/components/ui/Heading";
import { Footer } from "@/components/Footer";

export function ErrorLayout(props: ErrorLayoutProps) {
  const { children, className, title, sidebarContent } = props;

  return (
    <div className={clsx(classes.page, className)}>
      <Header />

      <main className={classes.main}>
        <Container maxWidth="lg">
          <div className={classes.title}>
            <Heading as="h1" size="3xl" align="center">
              {title}
            </Heading>
          </div>
          <div className={classes.layout}>
            <div className={classes.content}>{children}</div>

            <div className={classes.sidebar}>{sidebarContent}</div>
          </div>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
